<template>
    <div>
        <rkm-form
            v-if="loaded"
            ref="Form"
        >
            <rkm-tabs
                v-model="tabIndex"
                :tab-refs="tabRefs"
            >
                <rkm-tab
                    active
                    title="Identificação"
                >
                    <TabIdentificacao
                        ref="TabIdentificacao"
                        :form="form"
                        :model="model"
                        :id="id"
                    />
                </rkm-tab>

                <rkm-tab
                    title="Laboratório"
                    :disabled="model.tipoId != 1"
                >
                    <TabLaboratorio
                        ref="TabLaboratorio"
                        :form="form"
                        :model="model"
                        :id="id"
                    />
                </rkm-tab>

                <rkm-tab
                    title="Imagem"
                    :disabled="model.tipoId != 2"
                >
                    <TabImagem
                        ref="TabImagem"
                        :form="form"
                        :model="model"
                    />
                </rkm-tab>
            </rkm-tabs>
        </rkm-form>
    </div>
</template>

<script>

// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { formats, repository, stringCase, object, error } from '@/mixins'

// Components.
import TabIdentificacao from './components/identificacao/Form'
import TabLaboratorio from './components/laboratorio/Form'
import TabImagem from './components/imagem/Form'

export default {
    components: {
        TabIdentificacao,
        TabLaboratorio,
        TabImagem,
    },
    created() {
        this.repositories = {
            exame: this.getConectaSusRepository('parametrizacao.exame'),
            procedimento: this.getConectaSusRepository('sigtap.procedimento'),
        }
        this.load()
    },
    data: () => ({
        model: {
            laboratorio: [],
            imagem: [],
        },
        form: {},
        tabIndex: 0,
        tabRefs: [],
        loaded: false
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            const request = this.id
                ? this.repositories.exame.edit(this.id)
                : this.repositories.exame.create()

            request
                .then(({ data }) => {

                    this.form = data.form
                    this.model = Object.assign(
                        {
                            searchByApelido: false,
                        },
                        data.model
                    )

                    this.loaded = true

                    this.$nextTick().then(() => {

                        this.tabRefs = [
                            this.$refs.TabIdentificacao,
                            this.$refs.TabLaboratorio,
                            this.$refs.TabImagem,
                        ]
                    })
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save() {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                    this.setLoading()

                    const request = this.id
                        ? this.repositories.exame.update(this.id, this.prepareData())
                        : this.repositories.exame.store(this.prepareData())

                    request
                        .then(({ data }) => {

                            this.showSaveNotification()
                            this.$emit('save', data)
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        prepareData() {

            const data = this.clone(this.model)

            if(data.exigeProcedimento == true){

                data.procedimentoId = data.procedimento.id
                delete data.procedimento
            }

            if (data.imagem && !data.imagem.valor) {
                data.imagem.valor = '0,00'
            }

            if (data.laboratorio && !data.laboratorio.valor) {
                data.laboratorio.valor = '0,00'
            }

            if (!data.valorPpi) {
                data.valorPpi = '0,00'
            }

            return this.camelObjectKeysToSnakeRecursive(data)
        },
        validate() {
            return this.tabRefs[this.tabIndex].validate()
        },
    },
    mounted() {

    },
    mixins: [formats, repository, stringCase, object, error],
    props: {
        id: { type: Number }
    },
}
</script>

<style>
    .infor{
        color: #acacac;
        height: 15px;
        width: 15px!important;
        position: absolute;
        right: 8px;
        top: 5px;
        border-radius: 31px;
        padding: 3px;
        border: 1px solid #c2c2c2;
    }
    .borderf{
        display: inline-block;
        width: 100%;
        height: calc(1.5em + 0.75rem + 2px);
        padding: 0.375rem 1.75rem 0.375rem 0.75rem;
        font-size: 1rem;
        font-weight: 400;
        line-height: 1.5;
        color: #495057;
        vertical-align: middle;
        border: 1px solid #ced4da;
        border-radius: 0.25rem;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
    }
</style>